import { store as apolloStore } from '../../app/apollo-client-instance';
import { remote } from '../../store/operations';
import { get } from 'lodash-es';

const initBallparkPrices = prices => ({
  type: 'INIT_BALLPARK_PRICES',
  prices,
});

const _requestBallparkPrices = (dispatch, getState) => {
  const { moveId } = getState();
  apolloStore()
    .query(
      remote.searchMoveIqBallparkPrices({
        moveId,
      })
    )
    .then(result => {
      const ballparkPrices = get(
        result,
        'data.searchMoveIqBallparkPrices.ballparkPrices'
      );
      if (ballparkPrices) {
        const mappedResult = ballparkPrices.reduce(
          (obj, item) => ({
            ...obj,
            [item.homeSize]: [item.minPrice, item.maxPrice],
          }),
          {}
        );
        dispatch(initBallparkPrices(mappedResult));
      } else {
        dispatch(initBallparkPrices({}));
      }
    })
    .catch(() => {
      dispatch(initBallparkPrices({}));
    });
};

export const requestBallparkPrices = () => _requestBallparkPrices;
